export const userUpdatesMealPrep = meal_prep => ({
  type: 'Meal Prep Selected',
  data: {
    meal_prep,
  },
});

export const userViewMealPrepScreen = ({ customer_info }) => ({
  type: 'User views meal prep page',
  data: {
    customer_info,
  },
});
